module.exports = __webpack_public_path__ + "static/images/containers/ChallengesPromo/images/places.719a3fcf.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengesPromo/images/places.png
// module id = 2876
// module chunks = 11